const loadStatus = {
  active: 'active',
  complete: 'complete',
  fail: 'fail'
}

export default loadStatus
